import * as React from 'react';
import { makeIcon } from './makeIcon';
const ChevronUp = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("polygon", { transform: "translate(8.000000, 8.000000) rotate(180.000000) translate(-8.000000, -8.000000) ", points: "3.48262554 4.5 2 5.886997 8.00000025 11.5 14 5.886997 12.5173745 4.5 8.00000025 8.72600601" })));
export const ChevronUpIcon = makeIcon('chevron-up')(ChevronUp);
//# sourceMappingURL=ChevronUp.js.map